import assertNever from "../../global/assetNever";
import { FormElementType } from "../enums/formElementType";
import {IFormElement} from '../../formability/form_builder/models/formElements/formElement'
import {GenericType} from '~/interfaces/genericTypeInterfaces'
import {ModelType} from '~/enums/modelType'
import {InputFormatType} from '../../formability/form_builder/models/inputFormatType'

export default class FormElementDefinition {
  static getDisplayNameSafe(elementType: FormElementType) {
    switch (elementType) {
      case FormElementType.textField:
        return 'Input Field';
      case FormElementType.textArea:
        return 'Text Area';
      case FormElementType.dropdown:
        return 'Dropdown';
      case FormElementType.checkboxGroup:
        return 'Checkboxes';
      case FormElementType.radioButtonGroup:
        return 'Radio Buttons';
      case FormElementType.dateTimePicker:
        return 'Date/Time Picker';
      case FormElementType.uploadFiles:
        return 'File Uploader';
      case FormElementType.imageUpload:
        return 'Image Upload';
      case FormElementType.signature:
        return 'Signature';
      case FormElementType.heading:
        return 'Heading';
      case FormElementType.subheading:
        return 'Subheading';
      case FormElementType.paragraph:
        return 'Text';
      case FormElementType.stack:
        return 'Stack';
      case FormElementType.grid:
        return 'Grid';
      case FormElementType.pageBreak:
        return 'Page Break';
      case FormElementType.divider:
        return 'Divider';
      case FormElementType.validator:
        return 'Validator';
      case FormElementType.thirdParty:
        return 'Third Party Completer';
      case FormElementType.lookupField:
        return 'Lookup Field';
      case FormElementType.USPSAddress:
        return 'Address Validation';
      case FormElementType.panValidation:
        return "Pan Validation";
      case FormElementType.MMCCProviderValidation:
        return "Provider Verification";
      case FormElementType.unknown:
        break;
      case FormElementType.checkbox:
        return "Checkbox"
        break;
      case FormElementType.radioButton:
        return "Radio Button"
        break;
      case FormElementType.dropdownItem:
        break;
      case FormElementType.template:
        break;
      default:
        break;
    }
    return null;
  }

  static getDisplayName(elementType: FormElementType) {
    switch (elementType) {
      case FormElementType.textField:
      case FormElementType.textArea:
      case FormElementType.dropdown:
      case FormElementType.checkboxGroup:
      case FormElementType.radioButtonGroup:
      case FormElementType.dateTimePicker:
      case FormElementType.uploadFiles:
      case FormElementType.imageUpload:
      case FormElementType.signature:
      case FormElementType.heading:
      case FormElementType.subheading:
      case FormElementType.paragraph:
      case FormElementType.stack:
      case FormElementType.grid:
      case FormElementType.pageBreak:
      case FormElementType.divider:
      case FormElementType.validator:
      case FormElementType.thirdParty:
      case FormElementType.lookupField:
      case FormElementType.USPSAddress:
      case FormElementType.panValidation:
      case FormElementType.MMCCProviderValidation:
      case FormElementType.unknown:
      case FormElementType.checkbox:
      case FormElementType.radioButton:
      case FormElementType.dropdownItem:
      case FormElementType.template:
        return FormElementDefinition.getDisplayNameSafe(elementType)
      default:
        assertNever(elementType);
    }
    return null;
  }

  static getIcon(elementType: FormElementType) {
    switch (elementType) {
      case FormElementType.textField:
        return 'input icon';
      case FormElementType.textArea:
        return 'textarea icon';
      case FormElementType.dropdown:
        return 'dropdown icon';
      case FormElementType.checkboxGroup:
        return 'checkbox icon';
      case FormElementType.radioButtonGroup:
        return 'radio icon';
      case FormElementType.dateTimePicker:
        return 'datepicker icon';
      case FormElementType.uploadFiles:
        return 'upload icon';
      case FormElementType.imageUpload:
        return 'image-upload icon';
      case FormElementType.signature:
        return 'signature icon';
      case FormElementType.heading:
        return 'heading icon';
      case FormElementType.subheading:
        return 'subheading icon';
      case FormElementType.paragraph:
        return 'paragraph icon';
      case FormElementType.stack:
        return 'stack icon';
      case FormElementType.grid:
        return 'grid icon';
      case FormElementType.pageBreak:
        return 'pagebreak icon';
      case FormElementType.divider:
        return 'divider icon';
      case FormElementType.validator:
        return 'exclamation-circle icon';
      case FormElementType.thirdParty:
        return 'third-party icon';
      case FormElementType.template:
        return 'puzzle-piece icon';
      case FormElementType.lookupField:
        return 'magnifier icon';
      case FormElementType.USPSAddress:
        return 'location icon';
      case FormElementType.panValidation:
        return 'home-hash icon';
      case FormElementType.MMCCProviderValidation:
        return 'home-hash icon';
      case FormElementType.unknown:
        break;
      case FormElementType.checkbox:
        return 'checkbox icon';
        break;
      case FormElementType.radioButton:
        return 'radio icon';
        break;
      case FormElementType.dropdownItem:
        break;
      default:
        assertNever(elementType);
    }
    return null;
  }

  static getComponent(elementType: FormElementType) {
    switch (elementType) {
      case FormElementType.textField:
        return "text-field";
      case FormElementType.dateTimePicker:
        return "date-time-picker";
      case FormElementType.checkboxGroup:
        return "checkbox-group";
      case FormElementType.divider:
        return "divider";
      case FormElementType.validator:
        return "validator";
      case FormElementType.dropdown:
        return "dropdown";
      case FormElementType.grid:
        return "grid";
      case FormElementType.heading:
        return "heading";
      case FormElementType.pageBreak:
        return "page-break";
      case FormElementType.paragraph:
        return "paragraph";
      case FormElementType.radioButtonGroup:
        return "radio-button-group";
      case FormElementType.stack:
        return "stack";
      case FormElementType.signature:
        return "signature";
      case FormElementType.subheading:
        return "subheading";
      case FormElementType.textArea:
        return "text-area";
      case FormElementType.uploadFiles:
        return "upload-files";
      case FormElementType.thirdParty:
        return "third-party-completer";
      case FormElementType.USPSAddress:
        return "address-validation";
      case FormElementType.MMCCProviderValidation:
        return "mmcc-validation";
      case FormElementType.template:
        return "elements-template";
      case FormElementType.imageUpload:
        return 'image-upload';
      case FormElementType.lookupField:
        return "lookup-field";
      case FormElementType.panValidation:
        return "pan-validation";
      case FormElementType.unknown:
        break;
      case FormElementType.checkbox:
        break;
      case FormElementType.radioButton:
        break;
      case FormElementType.dropdownItem:
        break;
      default:
        assertNever(elementType);
    }
    return null;
  }

  static genericType(element: IFormElement): GenericType {
    switch (element.element_type) {
      case FormElementType.textField:
        if (element.format_type === InputFormatType.Numeric) {
          return ModelType.Number
        } else {
          return ModelType.Text
        }
      case FormElementType.textArea: // intentional fall-through
      case FormElementType.dropdown: // intentional fall-through
      case FormElementType.checkboxGroup: // intentional fall-through
      case FormElementType.radioButtonGroup: // intentional fall-through
      case FormElementType.checkbox: // intentional fall-through
      case FormElementType.radioButton: // intentional fall-through
      case FormElementType.dropdownItem: // intentional fall-through
      case FormElementType.paragraph: // intentional fall-through
      case FormElementType.validator:
        return ModelType.Text
      case FormElementType.uploadFiles: // intentional fall-through
      case FormElementType.imageUpload:
        return ModelType.File
      case FormElementType.stack: // intentional fall-through
      case FormElementType.grid: // intentional fall-through
      case FormElementType.thirdParty: // intentional fall-through
      case FormElementType.template: // intentional fall-through
      case FormElementType.USPSAddress: // intentional fall-through
      case FormElementType.lookupField: // intentional fall-through
      case FormElementType.panValidation: // intentional fall-through
      case FormElementType.MMCCProviderValidation:
        return ModelType.Object
      case FormElementType.dateTimePicker: // intentional fall-through
        return ModelType.DateTime
      case FormElementType.signature:
        return ModelType.Signature
      case FormElementType.heading: // intentional fall-through
      case FormElementType.subheading: // intentional fall-through
      case FormElementType.pageBreak: // intentional fall-through
      case FormElementType.divider: // intentional fall-through
      case FormElementType.unknown:
        return null
      default:
        assertNever(element.element_type)
    }
  }
}